import { render, staticRenderFns } from "./ItemEditorPanel.vue?vue&type=template&id=2880bd3c&"
import script from "./ItemEditorPanel.vue?vue&type=script&lang=js&"
export * from "./ItemEditorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports